import { notification } from 'antd';

import { gwGet, gwPost } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';
import createBaseActions, { handleGwData, setPostBody } from '../actionsFactory';
import actionTypes from '../actionsFactory/types';
import makeOrCacheApiReq from '../../utils/apiCache';
import bog from '../../utils/moreBog';
import clientCacheConfig from '../../config/clientCache';

const ERROR_NOTIFICATION_SHOW_SECS = 10;
const { GET_USER_ASSET_API } = API_PATH;
const {
  FETCH_USER_TRADE_FEE,
  SET_USER_TRADE_FEE,
  SET_CURRENCY_RATE_DATA,
  FETCH_CURRENCY_RATE_DATA,
  FETCH_USER_TRADE_FEE_ERROR,
  FETCH_CURRENCY_RATE_DATA_ERROR,
  SET_CUR_USER_ASSETS,
  SET_ALL_USER_ASSETS,
  SET_USER_ASSETS,
  SET_ALL_USER_ASSETS_BTC_VALUES,
  FETCH_FAVORITES_DATA,
  SET_FAVORITES_DATA,
  FETCH_FAVORITES_DATA_ERROR,
  HANDLE_FAVORITE_DATA_SUCCESS,
  HANDLE_FAVORITE_DATA_FAILED,
  FETCH_DRIBBLET_BTC,
  HANDLE_DRIBBLET_BNB,
  FETCH_DRIBBLET_LOG,
} = actionTypes;

const setUserTradeFee = createBaseActions(SET_USER_TRADE_FEE, 'data');
const setCurrencyRate = createBaseActions(SET_CURRENCY_RATE_DATA, 'data');
const setCurUserAssetsData = createBaseActions(SET_CUR_USER_ASSETS, 'data');
const setAllUserAssetsData = createBaseActions(SET_ALL_USER_ASSETS, 'data');
const setUserAssetsData = createBaseActions(SET_USER_ASSETS, 'data');
const setUserBtcValuationData = createBaseActions(SET_ALL_USER_ASSETS_BTC_VALUES, 'data');
const sendUserAssetPost = (locale, data) => gwPost(GET_USER_ASSET_API, { locale, ...setPostBody(data) });
const setFavoritesData = createBaseActions(SET_FAVORITES_DATA, 'data');
const handleFavoriteDataSuccess = createBaseActions(HANDLE_FAVORITE_DATA_SUCCESS, 'result');
const handleFavoriteDataError = createBaseActions(HANDLE_FAVORITE_DATA_FAILED, 'reason');
const setUserDribbleBtcData = createBaseActions(FETCH_DRIBBLET_BTC, 'data');
const setUserDribbleLogData = createBaseActions(FETCH_DRIBBLET_LOG, 'data');


export const fetchUserTradeFee = (symbol, locale) => async dispatch => {
  dispatch({ type: FETCH_USER_TRADE_FEE });
  try {
    const userTradeFee = await gwGet(`${API_PATH.USER_TRADE_FEE_API_PATH}?symbol=${symbol}`, {
      locale,
    });
    dispatch(setUserTradeFee(handleGwData(userTradeFee)));
  } catch (error) {
    dispatch({ type: FETCH_USER_TRADE_FEE_ERROR, error });
  }
};

export const fetchCurrencyRate = () => async dispatch => {
  dispatch({ type: FETCH_CURRENCY_RATE_DATA });
  try {
    const rate = await gwGet(API_PATH.CURRENCY_RATE_API_PATH, null, null, false);
    dispatch(setCurrencyRate(handleGwData(rate)));
  } catch (error) {
    dispatch({ type: FETCH_CURRENCY_RATE_DATA_ERROR, error });
  }
};

export const getProductsRequest = req => gwGet(API_PATH.PRODUCTS_API_PATH, null, req, false);

export const getProducts = async req => {
  let result = [];
  try {
    result = await makeOrCacheApiReq(
      API_PATH.PRODUCTS_API_PATH,
      () => getProductsRequest(req),
      res => res.success && Array.isArray(res.data)
    );
    result = handleGwData(result);
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
  return result;
};

export const fetchUserAssetByCoin = (asset, locale) => async dispatch => {
  dispatch(setCurUserAssetsData({}));
  let userAsset = await sendUserAssetPost(locale, { asset });
  userAsset = handleGwData(userAsset);
  userAsset = userAsset && userAsset.length && userAsset[0];
  dispatch(setCurUserAssetsData(userAsset));
};

export const fetchAllUserAssets = withClientApiCache => async dispatch => {
  try {
    let userAsset = await gwPost(
      GET_USER_ASSET_API,
      setPostBody(),
      null,
      true,
      {
        withClientApiCache,
        expire: clientCacheConfig.userAsset,
      }
    );
    userAsset = handleGwData(userAsset);
    dispatch(setAllUserAssetsData(userAsset));
  } catch (error) {
    // noop
  }
};

export const fetchUserAssets = (assets, locale) => async dispatch => {
  const queryAssets = [...assets];
  const useAssets = {};
  const promises = [];
  const sendPost = asset => sendUserAssetPost(locale, { asset });
  if (!queryAssets.includes('BNB')) {
    queryAssets.push('BNB');
  }
  queryAssets.forEach(asset => promises.push(sendPost(asset)));

  const res = await Promise.all(promises);
  res.forEach(assetInfo => {
    if (Array.isArray(handleGwData(assetInfo))) {
      const { asset, free } = handleGwData(assetInfo)[0];
      useAssets[asset] = free;
    }
  });
  dispatch(setUserAssetsData(useAssets));
};

export const getUserBtcValuation = withClientApiCache => async dispatch => {
  let userAllAsset = await gwPost(
    API_PATH.GET_USER_BTC_VALUATION_API,
    {},
    null,
    true,
    {
      withClientApiCache,
      expire: clientCacheConfig.btcValuation,
    }
  );
  userAllAsset = handleGwData(userAllAsset) || {};
  dispatch(setUserBtcValuationData(userAllAsset));
};

export const setInitFavorite = () => (dispatch, getState) => {
  const { isLoggedIn } = getState();
  if (isLoggedIn || typeof window === 'undefined' || !window.localStorage) return;

  let favorites = window.localStorage.getItem('favorites') || null;
  try {
    favorites = JSON.parse(favorites) || [];
    dispatch(setFavoritesData(favorites));
  } catch (error) {
    bog.error(`Error: init Favorite - val is ${favorites}, ${error ? error && error.message : ''}`);
  }
};

export const fetchFavoritesData = locale => async dispatch => {
  dispatch({ type: FETCH_FAVORITES_DATA });
  try {
    let favorites = await gwPost(API_PATH.FAVORITES_API_PATH, { locale, ...setPostBody() });
    favorites = handleGwData(favorites) || [];
    dispatch(setFavoritesData(favorites));
  } catch (error) {
    dispatch({ type: FETCH_FAVORITES_DATA_ERROR, error });
  }
};

export const handleFavorite = symbol => async (dispatch, getState) => {
  const {
    isLoggedIn, locale, localeData, favorites = [],
  } = getState();
  const i18n = localeData[locale];
  let url;
  let params = { symbol };
  const _favorites = favorites.slice();
  const index = _favorites.indexOf(symbol);
  if (index > -1) {
    _favorites.splice(index, 1);
    url = API_PATH.DELETE_FAVORITE_DATA_API_PATH;
    params = { symbols: [symbol] };
  } else {
    _favorites.push(symbol);
    url = API_PATH.ADD_FAVORITE_DATA_API_PATH;
  }

  dispatch(setFavoritesData(_favorites));

  if (isLoggedIn) {
    try {
      let result = await gwPost(url, { locale, ...setPostBody(params) });
      result = handleGwData(result);
      dispatch(handleFavoriteDataSuccess(result));
    } catch (error) {
      bog.error(`Error: favorite Data - ${error ? error && error.message : ''}`);
      notification.error({
        message: i18n.failed || 'Favorite Data Error',
        description: error ? error && error.message : '',
        duration: ERROR_NOTIFICATION_SHOW_SECS,
      });
      dispatch(handleFavoriteDataError(error));
    }
  } else {
    window.localStorage && window.localStorage.setItem('favorites', JSON.stringify(_favorites));
  }
};

export const fetchDribbletBtc = locale => async dispatch => {
  try {
    let userDribbletBtc = await gwPost(API_PATH.DRIBBLET_BTC_PATH, { locale, ...setPostBody() });
    userDribbletBtc = handleGwData(userDribbletBtc) || {};
    dispatch(setUserDribbleBtcData(userDribbletBtc));
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
};

export const handleDribbletBnb = (postData, locale) => async dispatch => {
  let result = '';
  try {
    result = await gwPost(API_PATH.DRIBBLET_BNB_PATH, { locale, ...setPostBody(postData) });
    dispatch({ type: HANDLE_DRIBBLET_BNB });
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
  return result;
};

export const fetchDribbletLog = locale => async dispatch => {
  try {
    let userDribbletLog = await gwPost(API_PATH.DRIBBLET_LOG_PATH, { locale, ...setPostBody() });
    userDribbletLog = handleGwData(userDribbletLog) || [];
    dispatch(setUserDribbleLogData(userDribbletLog));
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
};
